<div class="wtw-container">
  <div class="wtw-layout-col-span--12">
    <div class="terms-container">
      <h1 class="wtw-typography-display--md wtw-typography-font-weight--semibold">CoLab User Terms & Conditions</h1>
      <div class="terms-body">
        <p [innerHTML]="tncContent"></p>
      </div>
      <div class="terms-actions">
        <button class="wtw-typography-text--md wtw-typography-font-weight--medium back-btn" (click)="goBack()">
          <span>Back to Axis</span>
        </button>
        <button
          class="wtw-button wtw-button--primary-ultraviolet wtw-typography-text--md wtw-typography-font-weight--medium"
          (click)="acceptTnc()"
        >
          <span>Accept & Continue</span>
        </button>
      </div>
    </div>
  </div>
</div>
